import React, { useEffect, useMemo, useState } from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import {
    generalReports,
    generateURL,
    getAccountingReportList,
} from './constants'
import { RAJESH_TRANSPORT } from '../../../helper/companyIdhardcode'
import { urls } from '../../common/constants'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { GetRequest } from '../../common/api'
import { findObjctByValueFromArrayOfObject } from '../../common/helper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { decryptText } from '../../common/loginDecode'

const numericLoginFields = [
    'intCompanyID',
    'intUserID',
    'intBranchID',
    'intBranchCityID',
    'intRoleID',
    'IsBranchAdmin',
    'IsMTPLAdmin',
    'IsAdmin',
    'BusCrsCheckSum',
    'DefaultCurrencyID',
    'UseFormattedLRinReports',
    'UseToPayAsCOD',
    'AllowViewAllBranchReport',
    'AllowViewAllBranchOfCityReport',
    'AllowBranchInchargeRights',
    'AllowExportExcel',
    'AllowGroupofCompanies',
]

const normalizeLoginData = (paramsObject) => {
    return Object.entries(paramsObject).reduce((acc, [key, value]) => {
        acc[key] = numericLoginFields.includes(key) && value !== ''
            ? Number(value)
            : value

        return acc
    }, {})
}

const parseLegacyLoginData = (data) => {
    try {
        return JSON.parse(data)
    } catch (err) {
        return JSON.parse(decodeURIComponent(data))
    }
}

const MavenReportList = () => {
    const [loginData, setLoginData] = useState(null)
    const [selectedMenu, setSelectedMenu] = useState(null)
    const [searchText, setSearchText] = useState('')
    const [reportUrl, setReportUrl] = useState('')
    const [activeReports, setActiveReports] = useState([])
    const setLoader = useSetAtom(globalLoaderAtom)
    const setAlert = useSetAtom(alertAtom)
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const encrypted = params.get('data')
        if (encrypted) {
            try {
                const decryptedString = decryptText(encrypted)

                if (decryptedString && decryptedString !== 'ErrorInDecrypting') {
                    const searchParams = new URLSearchParams(decryptedString)
                    const paramsObject = Object.fromEntries(searchParams.entries())

                    setLoginData(normalizeLoginData(paramsObject))
                    return
                }

                const parsedData = parseLegacyLoginData(encrypted)
                setLoginData(parsedData)
            } catch (err) {
                console.log('Invalid login data')
            }
        }
    }, [])
    useEffect(() => {
        if (!loginData?.token) return

        sessionStorage.setItem('tokenV2', loginData?.token||'')
    }, [loginData?.token])
    useEffect(() => {
        if (!loginData?.intRoleID) return

        getRoleRightsData({
            RoleID: loginData?.intRoleID,
            IsLuggage: 0
        })

    }, [loginData?.intRoleID])

    const getRoleRightsData = (obj) => {
        setLoader(true)
        GetRequest(urls.getUserRollRightEditRight, obj)
            .then((res) => {
                setLoader(false)
                if (res.status === 'Success') {
                    setActiveReports(res.Data.Table)
                } else {
                    setAlert({ show: true, msg: res?.ErrMessage, nextId: '' })
                    setActiveReports([])
                }
            })
            .catch((err) => {
                setAlert({ show: true, msg: err?.Message, nextId: '' })
                setLoader(false)
                setActiveReports([])
            })
    }
    const { intCompanyID, intUserID, intBranchID, strCompanyName, strUserName, strBranchName, intBranchCityID, strCityName } = loginData || {}
    const openReport = (report) => {
        let url = generateURL(report, loginData)
        if (url) {
            window.location.href = url
            return
        }
    }
    const filterReportsByRights = (reports = []) => {
        if (!activeReports?.length) return []

        return reports.filter((report) => {
            // Keep reports that don't have a JobID
            if (!report.JobID) return true

            return (
                findObjctByValueFromArrayOfObject(
                    activeReports,
                    report.JobID,
                    'JobID',
                    'IsActive'
                ) === 1
            )
        })
    }

    const filterAndSortReports = (reports = []) => {
        const sortedReports = [...reports].sort((a, b) =>
            a.name.localeCompare(b.name)
        )

        if (!searchText.trim()) return sortedReports

        const search = searchText.toLowerCase()

        return sortedReports
            .filter((report) =>
                report.name.toLowerCase().includes(search)
            )
            .sort((a, b) => {
                const aName = a.name.toLowerCase()
                const bName = b.name.toLowerCase()

                const aStartsWith = aName.startsWith(search)
                const bStartsWith = bName.startsWith(search)

                if (aStartsWith && !bStartsWith) return -1
                if (!aStartsWith && bStartsWith) return 1

                return aName.localeCompare(bName)
            })
    }

    const filteredGeneralReports = useMemo(() => {
        return filterAndSortReports(
            filterReportsByRights(generalReports(loginData?.intCompanyID))
        )
    }, [searchText, activeReports, loginData])

    const filteredAccountingReports = useMemo(() => {
        return filterAndSortReports(
            filterReportsByRights(
                getAccountingReportList(0, loginData?.intCompanyID)
            )
        )
    }, [searchText, activeReports, loginData])
    const EmptyMessage = ({ message = 'No matching reports found' }) => {
        return (
            <div
                style={{
                    // marginTop: 20,
                    textAlign: 'center',
                    color: '#666',
                    fontSize: 16
                }}
            >
                {message}
            </div>
        )
    }
    return (
        <div>
            <style>
                {`
        .global-header {
            display: none;
        }

        body {
            margin: 0;
            background: #fff;
            font-family: Roboto, sans-serif;
            font-size: 16px;
            color: #000;
        }

        #root {
            zoom: 1.1;
        }

        .menu-list,
        .report-list {
            list-style: none;
            padding: 0;
            margin: 0;
        }

        .menu-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .menu-item,
        .report-item {
            padding: 14px 16px;
            border-left: 1px solid #dcdcdc;
            border-right: 1px solid #dcdcdc;
            border-top: 1px solid #dcdcdc;
            border-bottom: none;
            cursor: pointer;
            background: #fff;
            color: #000;
            font-family: Roboto, sans-serif;
            font-size: 16px;
            transition: background 0.2s ease;
        }

        .menu-item:last-child,
        .report-item:last-child {
            border-bottom: 1px solid #dcdcdc;
        }

        .menu-item:hover,
        .report-item:hover {
            background: #e3e3e3;
        }

        .forwardIosIcons {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #555;
        }

        .back-btn {
            margin: 0;
            padding: 14px 14px;
            cursor: pointer;
            background: #fff;
            color: #000;
            font-family: Roboto, sans-serif;
            font-size: 16px;
            border: none;
        }

        .back-btn:hover {
            background: #e3e3e3;
        }

        .search-container {
            position: relative;
            width: 100%;
        }

        .search-icon {
            position: absolute;
            left: 14px;
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
        }

        .search-input {
            width: 100%;
            padding: 12px 14px 12px 40px;
            border: 1px solid #dcdcdc;
            font-size: 16px;
            box-sizing: border-box;
            outline: none;
            background: white;
        }

        .search-input:focus {
            border-color: #999;
        }

        h2,
        h3 {
            font-family: Roboto, sans-serif;
            color: #000;
            font-weight: 500;
            margin: 0;
            background: #CFD3D9;
            padding: 20px 15px;
            border-left: 1px solid #dcdcdc;
            border-right: 1px solid #dcdcdc;
            border-top: 1px solid #dcdcdc;
        }`}
            </style>

            {selectedMenu && (
                <div>
                    <button
                        className="back-btn"
                        onClick={() => {
                            setSelectedMenu(null)
                            setSearchText('')
                        }}
                    >
                        ← Cargo Reports
                    </button>
                </div>
            )}
            {reportUrl && (
                <div
                    style={{
                        border: '1px solid #dcdcdc',
                        borderTop: 'none',
                        background: '#fff'
                    }}
                >
                    <iframe
                        src={reportUrl}
                        title="Report Viewer"
                        width="100%"
                        height="700px"
                        style={{
                            border: 'none'
                        }}
                    />
                </div>
            )}
            <h2>
                {selectedMenu
                    ? selectedMenu === 'general'
                        ? 'General Reports'
                        : 'Accounting Reports'
                    : 'Cargo Reports'}
            </h2>

            {selectedMenu && (
                <div className="search-container">
                    <FontAwesomeIcon
                        icon={faSearch}
                        color="#777"
                        className="search-icon"
                    />
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Search Report Name..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                </div>
            )}

            {!selectedMenu && (
                <ul className="menu-list">
                    <li
                        className="menu-item"
                        onClick={() => setSelectedMenu('general')}
                    >
                        General Reports
                        <span className="forwardIosIcons">
                            <ArrowForwardIosIcon />
                        </span>
                    </li>

                    <li
                        className="menu-item"
                        onClick={() => setSelectedMenu('accounting')}
                    >
                        Accounting Reports
                        <span className="forwardIosIcons">
                            <ArrowForwardIosIcon />
                        </span>
                    </li>
                </ul>
            )}

            {selectedMenu && (
                <div>
                    {selectedMenu === 'general' ? (
                        filteredGeneralReports.length > 0 ? (
                            <ul className="report-list">
                                {filteredGeneralReports.map((report) => (
                                    <li
                                        key={report.reportNo}
                                        className="report-item"
                                        onClick={() => openReport(report)}
                                    >
                                        {report.name}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <EmptyMessage />
                        )
                    ) : selectedMenu === 'accounting' ? (
                        filteredAccountingReports.length > 0 ? (
                            <ul className="report-list">
                                {filteredAccountingReports.map((report) => (
                                    <li
                                        key={report.reportNo}
                                        className="report-item"
                                        onClick={() => openReport(report)}
                                    >
                                        {report.name}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <EmptyMessage />
                        )
                    ) : (
                        ''
                    )}
                </div>
            )}
        </div>
    )
}

export default MavenReportList


